import { langEn } from './locales/en.js';

// #############################################################################
// #
// #  Export final common object with lazy loading support
// #
// #############################################################################

// Cache for loaded locales
const loadedLocales = {
  en: langEn,
};

// Lazy load locale function
export async function loadCommonLocale(locale) {
  // Return cached locale if already loaded
  if (loadedLocales[locale]) {
    return loadedLocales[locale];
  }

  // Load locale dynamically
  let localeModule;
  switch (locale) {
    case 'fr':
      localeModule = await import('./locales/fr.js');
      loadedLocales.fr = localeModule.langFr;
      return loadedLocales.fr;
    case 'de':
      localeModule = await import('./locales/de.js');
      loadedLocales.de = localeModule.langDe;
      return loadedLocales.de;
    case 'es':
      localeModule = await import('./locales/es.js');
      loadedLocales.es = localeModule.langEs;
      return loadedLocales.es;
    case 'it':
      localeModule = await import('./locales/it.js');
      loadedLocales.it = localeModule.langIt;
      return loadedLocales.it;
    case 'ja':
      localeModule = await import('./locales/ja.js');
      loadedLocales.ja = localeModule.langJa;
      return loadedLocales.ja;
    case 'zh':
      localeModule = await import('./locales/zh.js');
      loadedLocales.zh = localeModule.langZh;
      return loadedLocales.zh;
    case 'en':
      return loadedLocales.en;
    default:
      return loadedLocales.en; // Fallback to English
  }
}

// Export common object with only English loaded by default
export const i18nCommon = {
  en: langEn,
  // Other locales will be loaded on demand via loadCommonLocale()
};